import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Alerta } from '@/shared/domain/types';

/** Alertas guardadas SOLO en este navegador (sin cuenta). Se evalúan en el cliente al refrescar datos. */
export interface AlertasLocalState {
  items: Alerta[];
}

const alertasLocalSlice = createSlice({
  name: 'alertasLocal',
  initialState: { items: [] } as AlertasLocalState,
  reducers: {
    addAlertaLocal(state, a: PayloadAction<Alerta>) {
      state.items.unshift(a.payload);
    },
    updateAlertaLocal(state, a: PayloadAction<Alerta>) {
      const i = state.items.findIndex((x) => x.id === a.payload.id);
      if (i >= 0) state.items[i] = a.payload;
    },
    removeAlertaLocal(state, a: PayloadAction<string>) {
      state.items = state.items.filter((x) => x.id !== a.payload);
    },
    setAlertasLocal(state, a: PayloadAction<Alerta[]>) {
      state.items = a.payload;
    },
  },
});

export const { addAlertaLocal, updateAlertaLocal, removeAlertaLocal, setAlertasLocal } =
  alertasLocalSlice.actions;
export const alertasLocalReducer = alertasLocalSlice.reducer;
